import { SVGProps } from 'react';
const SvgArrowRightLg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 12H3M8 17l-5-5 5-5"
    />
  </svg>
);
export default SvgArrowRightLg;
